import { useContext } from 'react'

import { CloseCircleFilled } from '@ant-design/icons'

import { Personal } from '@/components/Personal'
import { useMessageAtom } from '@/pages/MesperyIM/store/message'
import MoreSrc from '@img/message/more.png'

import FolloweTip from '../components/FolloweTip'
import { ChaModalContext } from '../context'
import { EConversationType } from '../types/message'

export const ChatPanelHeader = () => {
  const { setGroupManage, currentConversation } = useMessageAtom()
  const { onClose } = useContext(ChaModalContext)

  return (
    <>
      <div className="ChatPanelHeader flx-justify-between">
        {/* 用户信息 */}
        <div className="flex">
          <span
            onClick={onClose}
            style={{
              marginRight: 5,
              marginLeft: -5,
              fontSize: 16,
              cursor: 'pointer'
            }}
          >
            <CloseCircleFilled style={{ color: '#FFC585' }} />
          </span>
          <Personal
            nickname={currentConversation?.session_name}
            avatar={currentConversation?.session_avatar_url}
            userData={{}}
          />
        </div>

        {/* 菜单 */}
        <div className="flx-justify-between">
          {currentConversation?.session_type === EConversationType.GROUP ? (
            <span
              className="btn-more"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setGroupManage(true)
              }}
            >
              <img src={MoreSrc} width={5} />
            </span>
          ) : null}
        </div>
      </div>
      {currentConversation?.session_id.indexOf('US_') === 0 ? (
        <FolloweTip />
      ) : null}
    </>
  )
}
